<template>
    <base-spinner :open="isloading"></base-spinner>
    <div class="site__body">
        <div class="block-header block-header--has-breadcrumb block-header--has-title">
            <div class="container">
                <div class="block-header__body">
                    <div class="flexbox-page-info-container">
                        <div class="flex-item-page-info-breadcrumbs">
                            <nav class="breadcrumb block-header__breadcrumb block-header__breadcrumb--and-title-only" aria-label="breadcrumb">
                                <ol class="breadcrumb__list">
                                    <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                    <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                        <router-link to="/" class="breadcrumb__item-link">Home</router-link>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--parent">
                                        <router-link to="/order-parts" class="breadcrumb__item-link">Order Parts</router-link>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last" aria-current="page">
                                        <span class="breadcrumb__item-link">Check Stock</span>
                                    </li>
                                    <li class="breadcrumb__title-safe-area" role="presentation"></li>
                                </ol>
                            </nav>
                        </div>
                        <div class="flex-item-page-info-title">
                            <h1 class="block-header__breadcrumb-slim">Check Stock</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="block">
            <div class="container">
                <base-message v-if="servermessages.length > 0" :servermessages="servermessages"></base-message>
            </div>
        </div>
        <search></search>
    </div>
    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block"></div>		
    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block">
        <div class="container">
            <product-check-stock :product="productData"></product-check-stock>
            <div class="block-space block-space--layout--divider-order-entry"></div>
            <available-locations-table :product="productData" :manufacturer="manufacturer" :partnumber="partnumber"></available-locations-table>
        </div>
    </div>
    <div class="container">
    </div>
    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block-space block-space--layout--divider-order-entry"></div>

</template>

<script>
import Search from '../orderparts/Search';
import ProductCheckStock from './ProductCheckStock';
import AvailableLocationsTable from './AvailableLocationsTable';
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from 'vuex';
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import * as GCONST from '../../../constants.js';

export default {
    name: 'CheckStock',
    data() {
        return {
            productData: {},
            servermessages: [],
            isloading: false
        }
    },
    components: {
        Search,
        ProductCheckStock,
        AvailableLocationsTable
    },
    props: {
        manufacturer: {
            type: String,
            required: true
        },
        partnumber: {
            type: String,
            required: true
        }
    },
    watch: {
        sharedmessagestatus(newVal) {
            if (newVal === 'complete') {
                // This indicates that messages were stored on the state
                let msgs = this.$store.getters['message/sharedmessages']

                if (msgs["CheckStock"] != undefined) {
                    this.servermessages = msgs["CheckStock"];
                    window.scrollTo(0, 0);
                }

            }
            this.$store.dispatch("message/resetStatus");
        },
        partnumber(newVal, oldVal) {
            if (newVal != oldVal) {
                this.getProductDetails();
            }
        }
    },
    computed: {
        ...mapGetters("message", [
            "sharedmessages",
            "sharedmessagestatus"
        ])
    },
    methods: {
        getProductDetails() {
                this.isloading = true;
                this.product = {};

                axiosvl.post(this.$store.getters['api/product_details_uri'], {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": { "value": this.$store.getters.customer },
                            "EIMFGC": { "value": this.manufacturer },
                            "EIITMC": { "value": this.partnumber },
                        },   
                    }
                })
                .then((response) => {
                    const fields = response.data.webroutine.fields;
                    let total = 1 * fields.EIEXCP.value;
                    const clearProductDesc = encodeURIComponent(fields.IMDESC.value);

                    this.productData = {
                        ID: fields.IMITMC.value,
                        IMITMC: fields.IMITMC.value,
                        sku: fields.IMITMC.value,
                        name: fields.IMDESC.value,
                        manufacturer: fields.IMMFGC.value,
                        manufacturername: fields.MCNAME.value,

                        mfgSeo: fields.MCNAME.value.replace(/ /g, "-"),
                        itemSeo: clearProductDesc.replace(/ /g, "-"),

                        // Based on Nic's comments on Issue #32 - Prices for a part in DMS depend on the Customer signed in (EHCUST) (assumptions made that some field names are incorrect)
                        // Price: EIECP
                        // Core Price: EICORP
                        // List Price: EILISTP (if setup for the customer)
                        yourprice: fields.EIEXCP.value,
                        coreprice: fields.EICORP.value,
                        listprice: fields.EILSTP.value,
                        cmdloc: fields.CMDLOC.value,
                        image: null,
                        // !NC! - Data below will be hardcoded for now until we can get clarification on where to pick them up
                        // fittingdesc: 'Part Fit for 2018 Chevrolet Truck Silverado 1500 LT 4WD 5.3L (x)',
                        // image_lg: '',
                        // image_sm: '',
                        // vendor_code: '94RS (x)',
                        // warranty: '(x)',
                        total : total,
                        XRMFGC: fields.XRMFGC.value,
                        XRITMC: fields.XRITMC.value,
                        IMIGSA: fields.IMIGSA.value,
                        IMISVALID: fields.IMISVALID.value,
                    }

                    const clApi = new CloudinaryApi;
                    clApi.item_sku = fields.IMITMC.value;
                    clApi.manufacturer_code = fields.IMMFGC.value;
                    clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
                        if(imgURL){
                            this.productData.image = imgURL;
                        }else{
                            this.productData.image = GCONST.IMAGE_PLACEHOLDER;
                        }
                    });
                    

                    this.isloading = false;
                })
                .catch((error) => {
                    console.log("error - " + error);
                    this.isloading = false;
                });
        }
    },
    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
        
        this.getProductDetails();
    }
}
</script>